export const styles = (theme) => ({
  checksTableContainer: {
    "max-height": 400,
    padding: 15
  },
  checkedBox: {
      '&&:hover': {
        backgroundColor: 'transparent',
      },
  },
  actionIcons: {
    padding: 8,
    boxShadow: "none",
    '&&:hover': {
      backgroundColor: 'transparent',
    },
  }
});
